import React from 'react';
import { observable, decorate, autorun } from 'mobx';
import _ from 'lodash';
import { checkRights } from '../functions';
import { authUserState } from './common';
import { GildChickenIcon, GildColdIcon, GildDessertIcon, GildDrinksIcon, GildFishIcon, GildGrillIcon, GildHotIcon, GildMeatIcon, GildOnigiryIcon, GildPizzaIcon, GildSaladIcon, GildSandwichIcon, GildSoupIcon, GildSushiIcon, GildVegetableIcon } from '../images/icons';

class DirectoryState {
	DirectoryItem = undefined;
	DirectoryType = "";
	ButtonLoading = false;
	ErrorCode = "";
	Directory = [];
	IsSendRequest = false;
	Active = true;

	/**
	 * РАзбор ответа от сервера со списком элементов
	 * @param {object} data ответ от сервера {Success, Error, [List]}
	 */
	setList(data) {
		var type = this.DirectoryType;
		
		this.Directory = data.Success && !_.isNull(data[type]) ? _.map(data[type], function (v) {
				return v.Price ? _.extend(v, { Price: (v.Price / 100).toFixed(2) }) : v 
			}) :  [];
		this.IsSendRequest = true;
	}

	/**
	 * Разбор данных элемента списка по полям
	 * @param {object} item элемент списка
	 * @param {[object]} fields список полей
	 */
	setItem(item, fields) {
		var dummy = { Id: -1 };
		_.each(fields, function (v) { dummy[v.Id] = "" });

		this.DirectoryItem = _.isUndefined(item) ? undefined : _.extend(_.clone(dummy), item);

		this.ButtonLoading = false;
		this.ErrorCode = "";
	}

	/**
	 * Сбор данных с формы редактирования элемента списка
	 * @param {string} id название параметра
	 * @param {string} value значение параметра
	 */
	collectItem(id, value) { this.DirectoryItem[id] = value; }

	/**
	 * Сбор данных элемента списка для отправки на сервер для сохранения
	 * @returns {object} данные
	 */
	getData() {
		var data = _.clone(this.DirectoryItem);

		if (data.Price) data.Price = data.Price * 100;

		if (this.DirectoryType === "Inventories") data = _.extend(data, { Active: true });

		return data;
	}
}
decorate(DirectoryState, {
	Directory: observable,
	IsSendRequest: observable,
	Active: observable,

	DirectoryItem: observable,
	ButtonLoading: observable,
	ErrorCode: observable,
});
export const directoryState = new DirectoryState();


class WorkShopState {
	constructor() {
		this.IsSendRequest = false;
		this.WorkShops = [];
		this.WorkShop = undefined;
		this.CanManage = false;
	}

	disposer = autorun(() => {
		if (!_.isUndefined(authUserState) && !_.isUndefined(authUserState.User) && !_.isNull(authUserState.User)) {
			this.CanManage = checkRights("ManageWorkShops");
		}
	});

	/**
	 * РАзбор ответа от сервера со списком элементов
	 * @param {{ Success : boolean, ErrorCode : string, WorkShops : [object]}} data ответ от сервера
	 */
	setList(data) {
		this.WorkShops = data.Success && !_.isNull(data.WorkShops) ? data.WorkShops : []
		this.IsSendRequest = true;
	}

	/**
	 * Выбор активного элемента
	 * @param {number} id 
	 */
	setItem(id) {
		if (_.isUndefined(id)) this.WorkShop = undefined
		else {
			var item = _.find(this.WorkShops, { Id : id })
			this.WorkShop = new WorkShop(item ? item : { Id : -1 })
		}
	}

	/** Получение набора колонок для таблицы */
	get columns () {
		var columns = { Name : {}, Icon : {
			Cell: row => (_.find(WorkShopIcons, { Id : row.original.Icon}) ? 
				_.find(WorkShopIcons, { Id : row.original.Icon}).Icon : ""),
			width: 100
		}}
		return this.CanManage ? _.extend(columns, { Edit: {}, Remove: {} }) : columns;
	}
}
decorate(WorkShopState, {
	IsSendRequest: observable,
	WorkShops: observable,
	WorkShop: observable,
})
export const workShopState = new WorkShopState();

class WorkShop {
	constructor(item) {
		this.Id = item && item.Id ? item.Id : -1;
		this.Name = item && item.Name ? item.Name : "";
		this.Icon = item && item.Icon ? item.Icon : -1;

		this.ErrorCode = "";
		this.ButtonLoading = false;
	}

	/**
	 * Сбор данных с формы
	 * @param {string} id название параметра
	 * @param {string} value значение параметра
	 */
	collect(id, value) { this[id] = value; }

	/**
	 * Проверка заполенных данных
	 * @returns {boolean} флаг валидности данных
	 */
	validate () {
		if (this.Icon === "" || this.Icon < 1)  {
			this.ErrorCode = "ICON_REQUIRED";
			return false;
		}
		return true;
	}

	/**
	 * Сбор данных для отправки на сервер
	 * @returns { Id : number, Name : string, Icon : number}
	 */
	getData() {
		return {
			Id : this.Id,
			Name : this.Name,
			Icon : this.Icon
		}
	}
}
decorate(WorkShop, {
	Name : observable,
	Icon: observable,

	ErrorCode: observable,
	ButtonLoading: observable
})

export const WorkShopIcons = [
	{ Id : 1, Icon : <GildHotIcon /> },
	{ Id : 2, Icon : <GildColdIcon /> },
	{ Id : 3, Icon : <GildPizzaIcon /> },
	{ Id : 4, Icon : <GildSushiIcon /> },
	{ Id : 5, Icon : <GildSoupIcon /> },
	{ Id : 6, Icon : <GildDrinksIcon /> },
	{ Id : 7, Icon : <GildOnigiryIcon /> },
	{ Id : 8, Icon : <GildSandwichIcon /> },
	{ Id : 9, Icon : <GildDessertIcon /> },
	{ Id : 10, Icon : <GildSaladIcon /> },
	{ Id : 11, Icon : <GildMeatIcon /> },
	{ Id : 12, Icon : <GildChickenIcon /> },
	{ Id : 13, Icon : <GildVegetableIcon /> },
	{ Id : 14, Icon : <GildFishIcon /> },
	{ Id : 15, Icon : <GildGrillIcon /> },
]